module.exports = __webpack_public_path__ + "static/media/06_FamiliePaschy_webfinal.cbf5c5af.jpg";